import { useState } from "react";
import { trpc } from "../../../utils/trpc";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { SeshTextInput } from "../base_components/sesh_text_input";
import { SubpageLoader } from "../sub_page_loader";

export function AdminWaitlistManager() {
	const metadata_query = trpc.admin.getWaitlistedMetadata.useQuery();

	if (!metadata_query.isSuccess) {
		return <SubpageLoader />;
	}

	return (
		<div className="flex flex-col gap-8">
			<div className="flex flex-col gap-2">
				{Object.keys(metadata_query.data).map((key) => (
					<Stat
						key={key}
						label={key}
						value={metadata_query.data[key]}
					/>
				))}
			</div>
			<GraduateUsersFromWaitlistInput />
			<AddServerToGraduatedWaitlistInput />
			<WaitlistersList />
		</div>
	);
}

function Stat(props: { label: string; value: string }) {
	return (
		<div className="flex gap-2">
			<div>{props.label}</div>
			<div className="font-bold">{props.value}</div>
		</div>
	);
}

function WaitlistersList() {
	const query = trpc.admin.getWaitlisters.useQuery();

	if (!query.isSuccess) {
		return <>Loading</>;
	}

	return (
		<div className="flex flex-col gap-2">
			{query.data.map((val) => (
				<div className="flex gap-2 rounded-md bg-base-dark px-4 py-2">
					{Object.keys(val).map((val2) => (
						<div>
							{val2} {val[val2].toString()}
						</div>
					))}
				</div>
			))}
		</div>
	);
}

function GraduateUsersFromWaitlistInput(props: {}) {
	const [input, setInput] = useState("");

	const context = trpc.useContext();

	const mutation = trpc.admin.graduateServersFromWaitlist.useMutation({
		onSuccess: () => {
			context.admin.getWaitlistedMetadata.invalidate();
			context.admin.getWaitlisters.invalidate();
		},
	});

	let isNumber = false;
	for (const char of input) {
		if (isNaN(parseInt(char))) {
			isNumber = false;
			break;
		}
		isNumber = true;
	}

	return (
		<div className="flex flex-col gap-2">
			<div className="font-bold">
				Num of Waitlisted Guilds to Graduate
			</div>
			<div className="flex gap-2">
				<div>
					<SeshTextInput
						input_props={{
							onChange: (e) => setInput(e.currentTarget.value),
							value: input,
						}}
						error_text={!isNumber ? "Must be a number" : undefined}
					/>
				</div>
				<div>
					<SeshPrimaryButton
						is_loading={mutation.isLoading}
						onClick={() =>
							mutation.mutate({
								count: parseInt(input),
							})
						}
						disabled={!isNumber}
					>
						Add
					</SeshPrimaryButton>
				</div>
			</div>
		</div>
	);
}

function isNumber(str: string) {
	if (str.length === 0) {
		return false;
	}
	for (const char of str) {
		if (isNaN(parseInt(char))) {
			return false;
		}
	}
	return true;
}

function AddServerToGraduatedWaitlistInput(props: {}) {
	const [server_input, setServerInput] = useState("");
	const [user_input, setUserInput] = useState("");

	const context = trpc.useContext();

	const mutation = trpc.admin.addServerToGraduatedWaitlist.useMutation({
		onSuccess: () => {
			context.admin.getWaitlistedMetadata.invalidate();
			context.admin.getWaitlisters.invalidate();
		},
	});

	const is_server_snowflake = isNumber(server_input);
	const is_user_snowflake = isNumber(user_input);

	return (
		<div className="flex flex-col gap-2">
			<div className="font-bold">Server to Graduate</div>
			<div className="flex gap-2">
				<div>
					<SeshTextInput
						input_props={{
							onChange: (e) =>
								setServerInput(e.currentTarget.value),
							value: server_input,
							placeholder: "Server ID",
						}}
						error_text={
							!is_server_snowflake
								? "Must be a snowflake"
								: undefined
						}
					/>
				</div>
				<div>
					<SeshTextInput
						input_props={{
							onChange: (e) =>
								setUserInput(e.currentTarget.value),
							value: user_input,
							placeholder: "User ID",
						}}
						error_text={
							!is_user_snowflake
								? "Must be a snowflake"
								: undefined
						}
					/>
				</div>
				<div>
					<SeshPrimaryButton
						is_loading={mutation.isLoading}
						onClick={() =>
							mutation.mutate({
								guild_id: server_input,
								user_id: user_input,
							})
						}
						disabled={!is_user_snowflake || !is_server_snowflake}
					>
						Add
					</SeshPrimaryButton>
				</div>
			</div>
		</div>
	);
}
